import { request, METHOD } from '@/utils/request'
import { BASE_URL } from '@/config/public'

// 产品基本信息接口
export async function rqtPostProductListForSelect(params) {
  return request(
    `${BASE_URL}/provider/wms/product/listproductforselect`,
    METHOD.POST_JSON_ENCRYPT,
    params
  )
}

export async function rqtPostListProductPage(params) {
  return request(
    `${BASE_URL}/provider/wms/product/list`,
    METHOD.POST_JSON_ENCRYPT,
    params
  )
}

export async function rqtPostProductSave(params) {
  return request(
    `${BASE_URL}/provider/wms/product/`,
    METHOD.POST_JSON_ENCRYPT,
    params
  )
}

export async function rqtPutProductUpdate(params) {
  return request(
    `${BASE_URL}/provider/wms/product/`,
    METHOD.PUT_JSON_ENCRYPT,
    params
  )
}

export async function rqtGetProduct(id, params) {
  return request(`${BASE_URL}/provider/wms/product/${id}`, METHOD.GET, params)
}

export async function rqtPostProductExtraFixedSave(id, params) {
  return request(
    `${BASE_URL}/provider/wms/product/${id}/extra/fixed`,
    METHOD.POST_JSON_ENCRYPT,
    params
  )
}

export async function rqtPutProductExtraFixedUpdate(id, params) {
  return request(
    `${BASE_URL}/provider/wms/product/${id}/extra/fixed`,
    METHOD.PUT_JSON_ENCRYPT,
    params
  )
}

export async function rqtPostProductExtra(id, params) {
  return request(
    `${BASE_URL}/provider/wms/product/${id}/extra`,
    METHOD.POST_JSON_ENCRYPT,
    params
  )
}

export async function rqtPostProductExtraStockSave(id, params) {
  return request(
    `${BASE_URL}/provider/wms/product/${id}/extra/stock`,
    METHOD.POST_JSON_ENCRYPT,
    params
  )
}

export async function rqtPutProductExtraStockUpdate(id, params) {
  return request(
    `${BASE_URL}/provider/wms/product/${id}/extra/stock`,
    METHOD.PUT_JSON_ENCRYPT,
    params
  )
}

export async function rqtPostProductExtraSecuritiesSave(id, params) {
  return request(
    `${BASE_URL}/provider/wms/product/${id}/extra/securities`,
    METHOD.POST_JSON_ENCRYPT,
    params
  )
}

export async function rqtPutProductExtraSecuritiesUpdate(id, params) {
  return request(
    `${BASE_URL}/provider/wms/product/${id}/extra/securities`,
    METHOD.PUT_JSON_ENCRYPT,
    params
  )
}

export async function rqtPostProductSalesFixedSave(id, params) {
  return request(
    `${BASE_URL}/provider/wms/product/${id}/sales/fixed`,
    METHOD.POST_JSON_ENCRYPT,
    params
  )
}

export async function rqtPutProductSalesFixedUpdate(id, params) {
  return request(
    `${BASE_URL}/provider/wms/product/${id}/sales/fixed`,
    METHOD.PUT_JSON_ENCRYPT,
    params
  )
}

export async function rqtPostProductSales(id, params) {
  return request(
    `${BASE_URL}/provider/wms/product/${id}/sales`,
    METHOD.POST_JSON_ENCRYPT,
    params
  )
}

export async function rqtDeleteProduct(id, params) {
  return request(
    `${BASE_URL}/provider/wms/product/${id}`,
    METHOD.DELETE,
    params
  )
}

export async function rqtPutProductApplyUpdate(id, params) {
  return request(
    `${BASE_URL}/provider/wms/product/modify-apply/${id}`,
    METHOD.PUT_JSON_ENCRYPT,
    params
  )
}

export async function rqtPutProductReleaseUpdate(id, params) {
  return request(
    `${BASE_URL}/provider/wms/product/release/${id}`,
    METHOD.PUT_JSON_ENCRYPT,
    params
  )
}

export async function rqtPostFloatProductListForSelect(params) {
  return request(
    `${BASE_URL}/provider/wms/product/float/list`,
    METHOD.POST_JSON_ENCRYPT,
    params
  )
}

export async function rqtPutProductSubmitAudit(id, params) {
  return request(
    `${BASE_URL}/provider/wms/product/audit/${id}`,
    METHOD.PUT_JSON_ENCRYPT,
    params
  )
}

// 添加产品基本信息的管理人、托管机构、居间机构等
export async function rqtPostSaveProductManager(params) {
  return request(
    `${BASE_URL}/provider/wms/product/productmanager`,
    METHOD.POST_JSON_ENCRYPT,
    params
  )
}

// 产品管理相关
export async function rqtPostProductManagerSave(id, params) {
  return request(
    `${BASE_URL}/provider/wms/product/${id}/manager`,
    METHOD.POST_JSON_ENCRYPT,
    params
  )
}

export async function rqtPostProductManager(id, params) {
  return request(
    `${BASE_URL}/provider/wms/product/${id}/manager/list`,
    METHOD.POST_JSON_ENCRYPT,
    params
  )
}

// 产品双录问题
export async function rqtPostProductQuestionSave(id, quesType, params) {
  return request(
    `${BASE_URL}/provider/wms/product/${id}/question/${quesType}`,
    METHOD.POST_JSON_ENCRYPT,
    params
  )
}

export async function rqtPostProductQuestion(id, params) {
  return request(
    `${BASE_URL}/provider/wms/product/${id}/question`,
    METHOD.POST_JSON_ENCRYPT,
    params
  )
}

export async function rqtPostProductQuestionTemplate(templateType, params) {
  return request(
    `${BASE_URL}/provider/wms/product/question/template/${templateType}`,
    METHOD.POST_JSON_ENCRYPT,
    params
  )
}

// 清算分配
export async function rqtPostProductLiquidationSave(id, params) {
  return request(
    `${BASE_URL}/provider/wms/product/${id}/liquidation`,
    METHOD.POST_JSON_ENCRYPT,
    params,
    { timeout: 600000 }
  )
}

export async function rqtPostProductLiquidation(id, params) {
  return request(
    `${BASE_URL}/provider/wms/product/${id}/liquidation/list`,
    METHOD.POST_JSON_ENCRYPT,
    params
  )
}

// 产品开放日
export async function rqtPostProductOpenDate(params) {
  return request(
    `${BASE_URL}/provider/wms/product/openday/definition/list`,
    METHOD.POST_JSON_ENCRYPT,
    params
  )
}

export async function rqtPostProductOpenDateList(params) {
  return request(
    `${BASE_URL}/provider/wms/product/openday/list`,
    METHOD.POST_JSON_ENCRYPT,
    params
  )
}

export async function rqtDeleteProductOpenDate(id, params) {
  return request(
    `${BASE_URL}/provider/wms/product/openday/${id}`,
    METHOD.DELETE,
    params
  )
}

export async function rqtPostProductOpenDateSave(params) {
  return request(
    `${BASE_URL}/provider/wms/product/openday`,
    METHOD.POST_JSON_ENCRYPT,
    params
  )
}

export async function rqtPostProductOpenDateUpdate(params) {
  return request(
    `${BASE_URL}/provider/wms/product/openday`,
    METHOD.PUT_JSON_ENCRYPT,
    params
  )
}

export async function rqtGetProductOpenDateById(id, params) {
  return request(
    `${BASE_URL}/provider/wms/product/openday/${id}`,
    METHOD.GET,
    params
  )
}
// 根据条件查询开放日列表没有分页
export async function rqtPostProductOpenDateListByQuery(params) {
  return request(
    `${BASE_URL}/provider/wms/product/openday/redemption/list`,
    METHOD.POST_JSON_ENCRYPT,
    params
  )
}

// 产品分红相关
export async function rqtPostProductDividendSave(id, params) {
  return request(
    `${BASE_URL}/provider/wms/product/${id}/dividend`,
    METHOD.POST_JSON_ENCRYPT,
    params,
    { timeout: 600000 }
  )
}

export async function rqtPostProductDividend(id, params) {
  return request(
    `${BASE_URL}/provider/wms/product/${id}/dividend/list`,
    METHOD.POST_JSON_ENCRYPT,
    params
  )
}

export async function rqtPostProductDividendList(params) {
  return request(
    `${BASE_URL}/provider/wms/product/dividend/list`,
    METHOD.POST_JSON_ENCRYPT,
    params
  )
}

export async function rqtGetProductDividendById(id, params) {
  return request(
    `${BASE_URL}/provider/wms/product/dividend/${id}`,
    METHOD.GET,
    params
  )
}

export async function rqtPutProductDividendUpdate(params) {
  return request(
    `${BASE_URL}/provider/wms/product/dividend`,
    METHOD.PUT_JSON_ENCRYPT,
    params
  )
}

export async function rqtDeletetProductDividend(id, params) {
  return request(
    `${BASE_URL}/provider/wms/product/dividend/${id}`,
    METHOD.DELETE,
    params
  )
}

export async function rqtGetExportProductDividend(params) {
  return request(
    `${BASE_URL}/provider/wms/product/dividend/export`,
    METHOD.GET,
    params,
    { responseType: 'blob' }
  )
}

export async function rqtPostImportProductDividend(params) {
  return request(
    `${BASE_URL}/provider/wms/product/dividend/import`,
    METHOD.POST,
    params,
    { timeout: 600000 }
  )
}

// 净值相关
export async function rqtPostProductNetValueSave(params) {
  return request(
    `${BASE_URL}/provider/wms/product/netvalue`,
    METHOD.POST_JSON_ENCRYPT,
    params
  )
}

export async function rqtPostProductNetValueUpdate(id, params) {
  return request(
    `${BASE_URL}/provider/wms/product/netvalue/${id}`,
    METHOD.PUT_JSON_ENCRYPT,
    params
  )
}

export async function rqtPostProductNetValueList(params) {
  return request(
    `${BASE_URL}/provider/wms/product/netvalue/list`,
    METHOD.POST_JSON_ENCRYPT,
    params
  )
}

export async function rqtGetProductNetValueById(id, params) {
  return request(
    `${BASE_URL}/provider/wms/product/netvalue/${id}`,
    METHOD.GET,
    params
  )
}

export async function rqtDeleteProductNetValue(id, params) {
  return request(
    `${BASE_URL}/provider/wms/product/netvalue/${id}`,
    METHOD.DELETE,
    params
  )
}

export async function rqtPutAuditProductNetValue(id, params) {
  return request(
    `${BASE_URL}/provider/wms/product/netvalue/audit/${id}`,
    METHOD.PUT_JSON_ENCRYPT,
    params,
    { timeout: 600000 }
  )
}

export async function rqtPutBatchAuditProductNetValue(params) {
  return request(
    `${BASE_URL}/provider/wms/product/netvalue/audit`,
    METHOD.PUT_JSON_ENCRYPT,
    params
  )
}

export async function rqtPostProductNetValueChatList(params) {
  return request(
    `${BASE_URL}/provider/wms/product/netvalue/chart/list`,
    METHOD.POST_JSON_ENCRYPT,
    params
  )
}

export async function rqtPostProductLatestNetValue(params) {
  return request(
    `${BASE_URL}/provider/wms/product/netvalue/latest`,
    METHOD.POST_JSON_ENCRYPT,
    params
  )
}
// 净值提交审核接口
export async function rqtPutsubmitAuditProductNetValue(id, params) {
  return request(
    `${BASE_URL}/provider/wms/product/netvalue/submit-audit/${id}`,
    METHOD.PUT_JSON_ENCRYPT,
    params
  )
}

// 信息披露相关
export async function rqtPostProductDisclosureList(params) {
  return request(
    `${BASE_URL}/provider/wms/product/disclosure/list`,
    METHOD.POST_JSON_ENCRYPT,
    params
  )
}

export async function rqtPostProductDefinitionDisclosureList(params) {
  return request(
    `${BASE_URL}/provider/wms/product/disclosure/definition/list`,
    METHOD.POST_JSON_ENCRYPT,
    params
  )
}

export async function rqtPostProductDisclosureSave(params) {
  return request(
    `${BASE_URL}/provider/wms/product/disclosure`,
    METHOD.POST_JSON_ENCRYPT,
    params
  )
}

export async function rqtPutProductDisclosureSave(id, params) {
  return request(
    `${BASE_URL}/provider/wms/product/disclosure/${id}`,
    METHOD.PUT_JSON_ENCRYPT,
    params
  )
}

export async function rqtDeleteProductDisclosure(id, params) {
  return request(
    `${BASE_URL}/provider/wms/product/disclosure/${id}`,
    METHOD.DELETE,
    params
  )
}

export async function rqtPutSyncProductDisclosure(id, params) {
  return request(
    `${BASE_URL}/provider/wms/product/disclosure/sync/${id}`,
    METHOD.PUT_JSON_ENCRYPT,
    params
  )
}

export async function rqtGetProductDisclosureById(id, params) {
  return request(
    `${BASE_URL}/provider/wms/product/disclosure/${id}`,
    METHOD.GET,
    params
  )
}

export async function rqtGetExportProductDisclosure(params) {
  return request(
    `${BASE_URL}/provider/wms/product/disclosure/export`,
    METHOD.GET,
    params,
    { responseType: 'blob', timeout: 600000 }
  )
}
// 修改产品信息披露文件上传状态
export async function rqtPutProductDisclosureFileStatus(id, params) {
  return request(
    `${BASE_URL}/provider/wms/product/disclosure/status/${id}`,
    METHOD.PUT_JSON_ENCRYPT,
    params
  )
}

// 业绩报酬计提
export async function rqtPostProductAccrualRewardList(params) {
  return request(
    `${BASE_URL}/provider/wms/product/reward/list`,
    METHOD.POST_JSON_ENCRYPT,
    params
  )
}

export async function rqtGetExportProductAccrualReward(params) {
  return request(
    `${BASE_URL}/provider/wms/product/reward/export`,
    METHOD.GET,
    params,
    { responseType: 'blob', timeout: 600000 }
  )
}

export async function rqtPostImportProductAccrualReward(params) {
  return request(
    `${BASE_URL}/provider/wms/product/reward/import`,
    METHOD.POST,
    params,
    { timeout: 600000 }
  )
}

export async function rqtPostImportProductNetLatestList(params) {
  return request(
    `${BASE_URL}/provider/wms/product/netvalue/latest/list`,
    METHOD.POST_JSON_ENCRYPT,
    params
  )
}
